var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFlagLeft = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 208.93 70.67",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.84,39.21,38,68.75a5,5,0,0,0,3.9,1.92h162a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5h-162A5,5,0,0,0,38,1.91L1.84,31.46A5,5,0,0,0,1.84,39.21Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlagLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flag_left.1980a1ed.svg";
export { ForwardRef as ReactComponent };